/*
 * Project: LegalPlace assistant
 * File: src/app/lp_app.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

import LpCallbacks from './callbacks';
import LpHrefParams from './continuity';
import LpEnvironment from './env';
import LpReferences from './refs/refs';
import LpIndexContainer from './indexes/indexes';
import LpActionsWindow from './actions';
import { getAndInitContract, getAndInitPrerender, getAndInitCheckout } from '../redux/actions/load_contract';
import LpMutex from './mutex/mutex';
import LpOperations from './ops/ops';
import LpLog from './log/log';
import { displayHeaderPhone, displayHeaderMobilePhone } from '../constants/phone';

/** @type {LpApp} */
let lpApp;

/**
 * This class is the main application of LegalPlace
 */
class LpApp {
  constructor() {
    this.init();
  }

  /**
     * The global initialization
     */
  init() {
    window.onresize = () => {
      this.initializeEnvironment();
    };
    this.initializeLogs();
    this.initializeOperations();
    this.initializeMutex();
    this.initializeEnvironment();
    this.intializeCallbacks();
    this.initializeActionTracking();
    this.initializeReferences();
    this.initializeIndexes();
    this.initializeHrefParams();
  }

  /**
     * This is for some general contract information
     */
  setContractUniqid(cUniqid) {
    this.contractUniqid = cUniqid;
    window.contract_id = cUniqid;
  }

  setNewCustomer(newCustomer) {
    this.newCustomer = newCustomer;
    window.newCustomer = newCustomer;
  }

  setContractTitle(cTitle) {
    this.contractTitle = cTitle;
    window.contractName = cTitle;
  }

  setContractMetaId(id) {
    return new Promise(resolve => {
        this.contractMetaId = parseInt(id, 10);
        window.contract_meta_id = id;
        resolve(id);
    })
  }

  setType(type, contractMetaId) {
        this.type = type;
        this.contractMetaId = contractMetaId;
        window.type = type;
        const noPhoneContractList = [302, 181, 680]

        // Display Phone on Header when only its a demarche type
        if (type === 'demarche' && noPhoneContractList.indexOf(contractMetaId) === -1 && !document.getElementById('phone-number')) {
          displayHeaderPhone()
          displayHeaderMobilePhone()
        }
  }
  setSupportPhone(str) {
    this.supportPhone = str;
    window.support_phone = str;
  }

  setIsPrerender(isPrerender) {
    this.isPrerender = !!isPrerender;
  }

  setPrerenderDoc(prerenderDoc) {
    this.prerenderDoc = parseInt(prerenderDoc, 10);
  }

  setDisableIntro(disable_intro){
    this.disable_intro = disable_intro;
  }

  setSubscription(subscribe = false) {
    // For now on Crea all subscription are on false
    // There is a value force_subscription on the docs API to use if necessary
    this.subscription = subscribe;
    window.contract_subscription = subscribe;
  }

  setIsPaidSession(isPaidSession) {
    this.paidSession = isPaidSession
  }

  setFullWidth(fullWidth) {
    this.fullWidth = fullWidth;
  }

  setPayed(isPayed) {
    this.isPayed = isPayed;
  }

  /**
     * This part is for reading the params from the href
     */
  initializeHrefParams() {
    this.continuity = new LpHrefParams();
  }

  /**
     * Initialize the environment informations (for bypassing the cross-browsing problem)
     * like : width and height, orientation, agent ,....
     */
  initializeEnvironment() {
    this.env = new LpEnvironment();
    window.lfoug = !!window.MSInputMethodContext && !!document.documentMode ? 70 : 30;
  }

    /**
    * Refernces manipulation,
    * A reference is the data we take from the json we read,
    */

  initializeReferences() {
    this.references = new LpReferences();
  }

  /**
     * Index manipulations
     * Using the data like it's got from the json may cause performence fallout,
     * So I oriented the strategy to be building indexes in order to use it in an
     * associative way.
     */
  initializeIndexes() {
    this.indexes = new LpIndexContainer();
  }

  /**
     * Actions tracking,
     * The flux is a great pattern, but using it with a huge data structures can cause
     * performance fallout, so we track our actions in order to minimize the update of
     * real DOM.
     */
  initializeActionTracking() {
    this.action_tracker = new LpActionsWindow();
  }


  /**
   * Initialize the store
   * Whe I used the redux's store in the first time, I couldn't have access all the time
   * to my context, so I had to iexport it as global variable, but it made me make sure
   * every time I use it.
   * So The best thing to do,
   * is to link the redux thing in the App directly, to centralize everything.
   */
  initializeStore(store) {
    this.store = store;
    this.dispatch = () => console.log('no dispatcher found');
    this.getState = () => 'no state ;)';
    this.redux_subscribe = () => 'No store';
    if (store) {
      this.dispatch = store.dispatch;
      this.getState = store.getState;
      this.redux_subscribe = store.subscribe;
    }
  }

  /**
   * DOM callbacks
   * The user experience imposes some rules to follow,
   * but the manipulation of such things in a random way
   * makes things more complex that it happen to be,
   * so here I centralized the thing so we can change the callbacks whenever
   * we want, and still having the initial callback saved.
   */
  intializeCallbacks() {
    this.callbacks = new LpCallbacks();
  }

  /**
     * the mutex thing.
     */

  initializeMutex() {
    this.mutex = new LpMutex();
    this.mutex.setMutex('history', true);
    this.mutex.setMutex('preview', true);
    this.mutex.setMutex('links', true);
  }


  initializeOperations() {
    this.ops = new LpOperations();
  }


  initializeLogs() {
    this.logs = new LpLog();
  }

  /**
     * The entry point (c'est simple non?)
     */
  main(contractName, uniqId = '') {
    this.setContractUniqid(uniqId);
    if (this.store) {
      this.intializeCallbacks();
      this.dispatch(getAndInitContract(contractName, uniqId));
    }
    this.setContractTitle(contractName);
    this.setSubscription();
  }

  mainCheckout(contractName, uniqid) {
    this.setContractUniqid(uniqid);
    if (this.store) {
      this.intializeCallbacks();
      this.dispatch(getAndInitCheckout(contractName, uniqid));
    }
    this.setContractTitle(contractName);
    this.setSubscription();
  }

  mainPrerender(uniqid, doc = 'main') {
    this.setIsPrerender(true);
    this.setPrerenderDoc(doc);
    if (this.store) {
      this.intializeCallbacks();
      this.dispatch(getAndInitPrerender(uniqid));
    }
  }


  /**
     * This is the singleton function, any auther instance of LpApp is not authorized.
     */
  static getInstance() {
    if (typeof lpApp === 'undefined') {
      lpApp = new LpApp();
    }
    return lpApp;
  }
}

lpApp = LpApp.getInstance();

export default lpApp;



// WEBPACK FOOTER //
// ./src/app/lp_app.js